// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { Div, H2 } from '@reuse';
import { Row, Column } from 'react-foundation';
import { breakup } from '@break';
import Button from '@global/buttons/white-button';

// Styles
// ------
const Jacket = styled(Div)`
    position: relative;
    width: 100%;
    background: transparent;
    padding-top: ${props => props.theme.padS};
    padding-bottom: ${props => props.theme.padS};

    ${breakup.medium`
        padding-top: ${props => props.theme.padM};
        padding-bottom: ${props => props.theme.padM};
    `}

    ${breakup.large`
        padding-top: 0;
        padding-bottom: 0;
        height: 100vh;
    `}
`;



// Exports
// ------
const CallToAction = ({text, to}) => (
    <Jacket pad mpad className="wow fadeIn">
        <Div valignLarge>
            <Row isExpanded>
                <Column small={12} medium={10} pushOnMedium={1} large={5}>
                    <H2 space>{text}</H2>
                    <Button to={to}>Get in touch</Button>
                </Column>
            </Row>
        </Div>
    </Jacket>
);

export default CallToAction;